module.exports = __webpack_public_path__ + "img/rancher-logo.05cc233f.svg";